'use client';

import { cn } from '@/lib/cn';
import {
  dropdownMenuItemVariants,
  DropdownMenuPortal,
  DropdownMenuSubContent,
  type DropdownMenuSubContentProps,
} from '@heidi/design-system/dropdown-menu';
import { ChevronLeft } from 'lucide-react';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { NavContext, PanelContext, SubContext, VariantContext } from './context';

export const AdaptiveMenuSubContent = ({
  children,
  className,
  ...props
}: DropdownMenuSubContentProps) => {
  const variant = React.useContext(VariantContext);
  const nav = React.useContext(NavContext);
  const sub = React.useContext(SubContext);

  if (variant === 'menu') {
    return (
      <DropdownMenuPortal>
        <DropdownMenuSubContent className={className} {...props}>
          {children}
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    );
  }

  // Single-level drill-down: a panel renders only while topmost, so nesting a
  // sub inside another sub's content is unsupported.
  if (!sub || !nav || nav.activePanelId !== sub.subId) return null;
  return (
    <PanelContext.Provider value={sub.subId}>
      <button
        type="button"
        onClick={() => nav.pop()}
        className={cn(
          dropdownMenuItemVariants({}),
          'min-h-11 w-full text-text-secondary'
        )}
      >
        <ChevronLeft className="size-4 rtl:-scale-x-100" />
        <span>
          {sub.title ?? <FormattedMessage defaultMessage="Back" id="cyR7KhiuaU" />}
        </span>
      </button>
      {children}
    </PanelContext.Provider>
  );
};
